export interface Actor {
  sub?: string;
  givenName?: string;
  familyName?: string;
  expiryTime?: string;
}
export interface AccountData {
  accountNumber?: number;
  profileRole?: string;
  accountName?: string;
  accountStatus?: string;
  accountCountry?: string;
}
export interface Session {
  id?: string;
  type?: string;
  userName?: string;
  partyId?: string;
  aboNum?: string;
  pinNUm?: string;
  warehouseId?: string;
  act?: Actor;
  lastName?: string;
  email?: string;
  currentAward?: string;
  highestAward?: string;
  accountExpirationDate?: string;
  /**
   * @deprecated - Use multiAccount instead
   */
  accounts?: AccountData[];
  uplineSponsorAccount?: string;
  renewalStatus?: string;
  renewalLifecycle?: string;
  currentAwardLevel?: string;
  primaryProfile?: boolean;
  accountCountry?: string;
  currentCountry?: string;
  multiAccount?: boolean;
  fulfillmentId?: string;
}

export interface Sessioninterface {
  session: Session;
  isAnonymous: () => boolean;
  isRegistered: () => boolean;
  isABO: () => boolean;
  isMember: () => boolean;
  isEmployee: () => boolean;
  isActor: () => boolean;
}
export interface SessionServiceInterface {
  getSession: () => Sessioninterface;
  setSession: (config: Session) => void;
}
export enum UserType {
  ANONYMOUS = 'Anonymous',
  ABO = 'BUSINESS_OWNER',
  REGISTERED = 'CUSTOMER',
  MEMBER = 'MEMBER',
  EMPLOYEE = 'EMPLOYEE',
}

declare global {
  // eslint-disable-next-line
  var SessionService: SessionServiceInterface;
  interface Window {
    // eslint-disable-next-line
    SessionService: SessionServiceInterface;
  }
}
